// The college half of the sign-up school step. The high-school half keeps its
// existing state; this only decides which one shows and what extra fields go
// in the single register request.
export const ELIGIBILITY_YEARS = [1, 2, 3, 4, 5];

export const EMPTY_COLLEGE = Object.freeze({
  college: false,
  name: '',
  unitid: null,
  eligibility: '',
});

// Not college: nothing extra to complete, so the caller's own school check applies.
export function collegeComplete(c) {
  if (!c.college) return true;
  return Boolean(c.name.trim()) && Boolean(c.eligibility);
}

// null for high school; the caller keeps its existing school/city/state/zip payload.
export function collegePayload(c) {
  if (!c.college) return null;
  const name = c.name.trim();
  return {
    school: name,
    school_city: null,
    school_state: null,
    school_zip: null,
    school_level: 'college',
    college_name: name,
    college_unitid: c.unitid ?? null,
    eligibility_years_remaining: Number(c.eligibility),
  };
}
